import React from 'react';

import { Drupal_ParagraphQuote } from '../../generated/graphql';
import './quote.scss';

interface Props {
  quote?: Drupal_ParagraphQuote;
}

const Quote = ({ quote }: Props) => {
  if (!quote) {
    return null;
  }
  return (
    <section className="quote lucid-container lucid-container--flex">
      <blockquote className="quote__box">
        <div className="callout-text container--fullwidth">
          {quote.fieldQuote}
        </div>
        <div className="quote__attribution-text quote__box-container--fullwidth">
          {quote.fieldAttribution}
        </div>
      </blockquote>
    </section>
  );
};

export default Quote;
